'use strict';

import React, {useCallback, useRef} from 'react';
import {h, Fragment} from 'preact';
import mix from '../../../helpers/mix';
import {block, unblock} from '../../../src/block-ui';

export default function CartItemDesktop(props) {
    const {basket, index, item, product, remove, push, spin, isPage} = props;
    const $item = useRef(null);

    const $guaranteeCheckbox = useRef(null);
    const $guaranteeNumber = useRef(null);

    const guaranteeCheckboxClicked = useCallback(
        event => {
            $guaranteeNumber.current.focus();
        },
        [$guaranteeNumber]
    );

    const guaranteeFieldChanged = useCallback(
        (id, event) => {
            $guaranteeCheckbox.current.checked = true;

            const code = event.target.value;
            $.post('/basket/guaranteeCode/', {id, code});
        },
        [$guaranteeCheckbox]
    );

    const basketCheckbox = useCallback(
        id => {
            const $el = $(`#basketCheckbox${id}`);
            block();

            $.ajax({
                url: '/basket/status/',
                data: {id, status: $el.is(':checked') ? 0 : 1},
                type: 'post',
                success: response => {
                    $item.current.style.backgroundColor = response.status ? '#475365' : '#654747';

                    unblock();
                },
            });
        },
        [$item]
    );

    return (
        <div
            className='view border-r'
            style={item.basket_no_add === 1 ? {backgroundColor: '#654747'} : {}}
            ref={$item}
            key={item.id}>
            {/* Удалить из корзины */}
            {!product.disableRemoval && (
                <div
                    className='info_close'
                    title={trans('basketItem.delete')}
                    onClick={remove.bind(this, item, index)}></div>
            )}

            {basket.isOperator && isPage && (
                <input
                    type='checkbox'
                    name='my_check'
                    style={{position: 'absolute', right: '7px', top: '50%', marginTop: '-6px'}}
                    id={`basketCheckbox${item.id}`}
                    onClick={basketCheckbox.bind(this, item.id)}
                    autoComplete='off'
                    defaultChecked={item.basket_no_add === 0}
                />
            )}

            <div className='block_img'>
                {/* Кликните, чтоб перейти к подробному описанию товара */}
                <a href={product.url} title={trans('basketItem.see_full')}>
                    <img src={product.imageUrl} alt={product.alt} />
                </a>
            </div>

            <div className='description'>
                {/* Название: */}
                <div className='description_row'>
                    <div className='name'>{trans('basketItem.name')}</div>
                    {/* Кликните, чтоб перейти к подробному описанию товара */}
                    <div className='info'>
                        <a href={product.url} title={trans('basketItem.see_full')}>
                            {product.name}
                        </a>
                    </div>
                </div>

                {/* Код товара: */}
                {product.articul && (
                    <div className='description_row'>
                        <div className='name'>{trans('basketItem.code')}</div>
                        <div className='info'>{product.articul}</div>
                    </div>
                )}

                {/* Наличие: */}
                {product.availableValue && (
                    <div className='description_row'>
                        <div className='name'>{trans('basketItem.availability')}</div>
                        <div className='info' dangerouslySetInnerHTML={{__html: product.available}}></div>
                    </div>
                )}

                {!props.isPopup && product.isGuaranteed && (
                    <div style={{display: 'block'}}>
                        {/*Эта запчасть для гарантийной заявки*/}
                        <label style={{color: '#fff'}}>
                            <input
                                type='checkbox'
                                className='guarantee-checkbox'
                                style={{verticalAlign: 'middle'}}
                                onClick={guaranteeCheckboxClicked.bind(this)}
                                checked={!!item.guaranteeCode}
                                ref={$guaranteeCheckbox}
                            />
                            &nbsp;
                            {trans('cart.guarantee_item')}
                            &nbsp;
                            <input
                                type='text'
                                className='guarantee-number'
                                style={{width: '95px', verticalAlign: 'middle'}}
                                value={item.guaranteeCode || ''}
                                onChange={guaranteeFieldChanged.bind(this, item.id)}
                                ref={$guaranteeNumber}
                            />
                        </label>
                    </div>
                )}
            </div>

            <div className='number' style={product.disableQuantity ? {visibility: 'hidden'} : {}}>
                <div className='basket_shtk'>{product.quantityUnitName}</div>

                <span className='ui-spinner ui-widget ui-widget-content ui-corner-all'>
                    <input
                        className={`spinner_${product.id} spinner ui-spinner-input`}
                        autoComplete='off'
                        value={item.quantity}
                        aria-valuenow='0'
                        role='spinbutton'
                        onKeyUp={push.bind(this, item, index, true)}
                        onInput={push.bind(this, item, index, true)}
                        onBlur={push.bind(this, item, index, false)}
                    />

                    <a
                        className='ui-spinner-button ui-spinner-up ui-corner-tr ui-button ui-widget ui-state-default ui-button-text-only'
                        tabIndex='-1'
                        role='button'
                        aria-disabled='false'
                        onClick={spin.bind(this, item, index, 'plus')}>
                        <span className='ui-button-text'>
                            <span className='ui-icon ui-icon-triangle-1-n'>▲</span>
                        </span>
                    </a>

                    <a
                        className='ui-spinner-button ui-spinner-down ui-corner-br ui-button ui-widget ui-state-default ui-button-text-only'
                        tabIndex='-1'
                        role='button'
                        aria-disabled='false'
                        onClick={spin.bind(this, item, index, 'minus')}>
                        <span className='ui-button-text'>
                            <span className='ui-icon ui-icon-triangle-1-s'>▼</span>
                        </span>
                    </a>
                </span>
            </div>

            <div className='price' style={{width: '110px'}}>
                <div className='wrap'>
                    {/* Цена: */}
                    {trans('basketItem.price')}

                    {(item.isPriceChanged || basket.partnerBasketModeActive) && (
                        <span className='price_old'>
                            {item.price} {product.price.show_symb}
                        </span>
                    )}

                    {basket.partnerBasketModeActive && item.productDiscountedPrice > 0 ? (
                        <span>
                            {item.productDiscountedPrice} {product.price.show_symb}
                        </span>
                    ) : (
                        <span style={item.isOptPrice ? {color: 'yellow'} : {}}>
                            {item.isPriceChanged ? product.price.final_price : item.price} {product.price.show_symb}
                        </span>
                    )}

                    {/*СКИДКА*/}
                    {item.isOptPrice && (
                        <span style={{color: 'yellow', fontSize: '10px'}}>{trans('cartLayout.discount')}</span>
                    )}
                </div>
            </div>

            <div className='interest'>
                {basket.isOperator && !isPage && (
                    <div className='like-btn' style={{background: 'none'}}>
                        <a
                            rel="nofollow"
                            href='javascript:void(0)'
                            className='js-interest-toggle'
                            data-good-id={product.id}
                            title={trans('good.interest')}
                            style={{padding: '0', background: 'none'}}>
                            <img src={mix.img('images/vopros.jpg')} width='20' />
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
}
